module.exports = __webpack_public_path__ + "static/media/Slide95.c8197603.JPG";